import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./contexts/CartContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import CartPage from "./pages/CartPage";
import AboutPage from "./pages/AboutPage";
import StarlinkPage from "./pages/StarlinkPage";
import AdminPage from "./pages/AdminPage";
import AfiliadosPage from "./pages/AfiliadosPage";
import "@/App.css";

function App() {
  return (
    <ThemeProvider>
      <CartProvider>
        <BrowserRouter>
          <div className="min-h-screen flex flex-col bg-background">
            <Navbar />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/carrinho" element={<CartPage />} />
                <Route path="/sobre" element={<AboutPage />} />
                <Route path="/starlink" element={<StarlinkPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/afiliados" element={<AfiliadosPage />} />
              </Routes>
            </main>
            <Footer />
          </div>
          <Toaster position="bottom-right" richColors />
        </BrowserRouter>
      </CartProvider>
    </ThemeProvider>
  );
}

export default App;
